
export class CheckoutPaymentMethodSwitch
{
    /**
     * Initialize payment method switcher
     */
    init()
    {
        $(document).on('click', '.checkout_item__payment_method__header', function(e){
            e.preventDefault();

            $('.checkout_item__payment_method.active').removeClass('active');
            const $pm = $(this).closest('.checkout_item__payment_method');
            $pm.addClass('active');

        });
    }

    /**
     * Get selected payment method
     * @return {jQuery|undefined|null}
     */
    static getSelectedPaymentMethod()
    {
        const $activePm = $('.checkout_item__payment_method.active');
        return $activePm.data('pm-type');
    }

    /**
     * Credit card payment method
     * @return {boolean}
     */
    static isPmCreditCard()
    {
        return CheckoutPaymentMethodSwitch.getSelectedPaymentMethod() === 'cc';
    }

    /**
     * Twint payment method
     * @return {boolean}
     */
    static isTwint()
    {
        return CheckoutPaymentMethodSwitch.getSelectedPaymentMethod() === 'twint';
    }

    /**
     * @return {boolean}
     */
    static isApplePay()
    {
        return CheckoutPaymentMethodSwitch.getSelectedPaymentMethod() === 'apple_pay';
    }

    /**
     * @return {boolean}
     */
    static isSofort()
    {
        return CheckoutPaymentMethodSwitch.getSelectedPaymentMethod() === 'sofort';
    }

    /**
     * @return {boolean}
     */
    static isIdeal()
    {
        return CheckoutPaymentMethodSwitch.getSelectedPaymentMethod() === 'ideal';
    }

    /**
     * @return {boolean}
     */
    static isAlternativePm()
    {
        return CheckoutPaymentMethodSwitch.isTwint() || CheckoutPaymentMethodSwitch.isApplePay() || CheckoutPaymentMethodSwitch.isSofort() || CheckoutPaymentMethodSwitch.isIdeal();
    }
}
